import { render, staticRenderFns } from "./OnCanvasDragHandle.vue?vue&type=template&id=728365e8&"
import script from "./OnCanvasDragHandle.vue?vue&type=script&lang=ts&"
export * from "./OnCanvasDragHandle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports